<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">

    <!-- Loading spinner (kept out of form) -->
    <div class="text-center" [hidden]="!isLoading">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <!-- Login card -->
    <div
      class="card SmallForm rounded"
      [hidden]="isLoading"
      [class.SmallArabicFont]="globalService.isRTL === true"
    >
      <div class="card-body MyCardBody rounded-bottom">

        <!-- 🔑 Autofill-safe form -->
        <form
          #myForm="ngForm"
          autocomplete="on"
          role="form"
          name="loginForm"
          (ngSubmit)="onSubmit(myForm)"
        >

          <!-- LOGIN SCREEN -->
          <div [hidden]="firstTime !== false || agreementLink !== ''">

            <p class="text-center">Login Screen</p>

            <div
              class="form-group row m-3"
              [class.text-right]="globalService.isRTL === true"
            >
              <input
                type="email"
                inputmode="email"                
                id="username"
                class="form-control text-left mb-3"
                dir="ltr"
                name="username"
                ngModel
                required
                autocomplete="username"
                placeholder="Username"
              />

              <input
                type="password"
                inputmode="text"
                id="password"
                class="form-control text-left"
                dir="ltr"
                name="password"
                ngModel
                required
                minlength="6"
                autocomplete="current-password"
                placeholder="Password"
              />
            </div>

            <div
              class="form-group m-3"
              [class.SmallArabicFont]="globalService.isRTL === true"
            >
              <div class="row">
                <div class="col-6">
                  <button class="btn btn-primary btn-block" type="submit">
                    <i *ngIf="isLogging" class="fas fa-spinner fa-spin"></i>
                    {{ globalService.Get("LOGIN") }}
                  </button>
                </div>
                <div class="col-6">
                  <a
                    class="btn btn-outline-primary btn-block"
                    routerLink="/signup"
                  >
                    {{ globalService.Get("SIGNUP") }}
                  </a>
                </div>
              </div>
            </div>

          </div>
        </form>

        <!-- ERROR MESSAGE -->
        <div class="form-group mx-3">
          <ngb-alert
            *ngIf="!failureClosed && error"
            type="danger"
            class="text-center mt-4"
            (close)="failureClosed = true"
          >
            {{ globalService.Get(error) }}
          </ngb-alert>
        </div>

        <!-- FORGOT PASSWORD -->
        <div class="form-group text-small text-center">
          <a
            class="link pointer"
            [class.SmallArabicFont]="globalService.isRTL === true"
            routerLink="/resetrequest"
          >
            <small>{{ globalService.Get("FORGOTPASSWORD") }}</small>
          </a>
        </div>

        <!-- FIRST-TIME / AGREEMENT FLOW -->
        <div
          [hidden]="
            isLoading ||
            !(firstTime === true || (agreementLink && agreementLink !== ''))
          "
          [class.SmallArabicFont]="globalService.isRTL === true"
        >
          <p class="text-center text-danger welcomeHeader">
            {{ churchName }}
          </p>

          <p class="text-center text-secondary welcomeHeader">
            {{ globalService.Get("WELCOME") + ' ' + fullName }}
          </p>

          <p
            class="text-center text-secondary"
            *ngIf="agreementLink"
          >
            {{ globalService.Get("NEW_TERMS_MESSAGE") }}
          </p>

          <div class="form-group text-center mt-2">
            <div class="row">

              <div
                class="col-6"
                *ngIf="overrideMembership === 0 && firstTime"
              >
                <button
                  class="btn btn-success btn-block"
                  (click)="SetAsMembers()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("YES") }}
                </button>
              </div>

              <div
                class="col-6"
                *ngIf="overrideMembership === 0 && firstTime"
              >
                <button
                  class="btn btn-danger btn-block"
                  (click)="SetAsGuests()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("NO") }}
                </button>
              </div>

              <div
                class="col-12"
                *ngIf="overrideMembership > 0 || !firstTime"
              >
                <button
                  class="btn btn-primary btn-block"
                  (click)="Profile()"
                  [disabled]="!termsAccepted && agreementLink"
                >
                  {{ globalService.Get("PROCEED_WITH_LOGIN") }}
                </button>
              </div>

            </div>
          </div>

          <div
            class="row text-center mt-3 nomargin"
            *ngIf="agreementLink"
          >
            <div
              class="form-group col-10"
              [class.ml-4]="!globalService.isRTL"
              [class.mr-4]="globalService.isRTL"
            >
              <input
                type="checkbox"
                class="form-check-input mt-2"
                (click)="AcceptAgreement()"
              />
              <label class="form-check-label">
                {{ globalService.Get("AGREE_TO_TERMS") }}
                <a [href]="agreementLink">
                  {{ globalService.Get("CLICK_TO_REVIEW") }}
                </a>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>